import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8 border-t border-brand-green/10 text-center" data-id="element-99" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto" data-id="element-100" data-mp="3ghc3g4fxp7pa">
        <div className="text-3xl font-black text-brand-green mb-6 tracking-wider" data-id="element-101" data-mp="32oe281gt8ldt">
          MODODIGITAL™
        </div>

        <p className="text-lg font-medium text-white mb-2" data-id="element-102" data-mp="36qhfmvn1i01q">
          El sistema N°1 de transformación física en casa para Argentina
        </p>
        <p className="text-gray-400 mb-12" data-id="element-103" data-mp="3ud7gvurkdqla">
          Porque bajar la panza no debería costarte todos los lunes del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-gray-500 mb-12" data-id="element-104" data-mp="3levk1b03twke">
          <a href="mailto:soporte.mododigital@gmail.com" className="hover:text-brand-green transition-colors flex items-center gap-2" data-id="element-105" data-mp="3qc40n75ltsjj">
            📧 soporte.mododigital@gmail.com
          </a>
          <a href="https://www.mododigital.shop" target="_blank" rel="noopener noreferrer" className="hover:text-brand-green transition-colors flex items-center gap-2" data-id="element-106" data-mp="2ew6yuico3e4w">
            🌐 www.mododigital.shop
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-4" data-id="element-107" data-mp="3v91a9qxdlv7o">
          <p data-id="element-108" data-mp="3q8di31xev8bv">© ModoDigital™ 2026 — Todos los derechos reservados</p>
          <p className="italic" data-id="element-109" data-mp="830hxf7jlyyw">"El próximo lunes puede ser diferente."</p>
        </div>
      </div>
    </footer>;
}